import {Col, DatePicker, DatePickerProps, Form, Input, message, Row, Table, Typography} from "antd";
import {WdiCardTitle, wdiCore, WdiInput, WdiModalAppProps} from "@/components/WdiControls";
import React, {useEffect, useRef, useState} from "react";
import {ProFormInstance} from "@ant-design/pro-form";
import {Product} from "@/services/mdm/product";
import DataStore from "@/components/GridWidget/DataStore";
import {WdiSelect, WdiSelectFormat} from "@/components/WdiControls/WdiSelect";
import {ResponseStatus} from "@/utils/request";
import {WdiInputNumber} from "@/components/WdiControls/WdiInputNumber";
import moment from "moment";
import {WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {FormGoodsShipping, FormSp} from "@/services/sales/sp";
import {ShipTo} from "@/services/mdm/shipto";
import {WdiPanel} from "@/components/WdiControls/WdiPanel";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import {SoldTo} from "@/services/mdm/soldto";
import {Enum} from "@/enums/system";
import {ProductPrice} from "@/services/mdm/productprice";
import dayjs from "dayjs";

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  record: any;
  index: number;
  children: React.ReactNode;
}

const FormGoodsEditApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const editingFormGoodsDetail = useRef<API.FormGoodsDetailVo>();
  const {data} = props;

  const [dataSource, setDataSource] = useState<API.FormGoodsDetailVo[]>([]);
  const [formGoodsDetail, setFormGoodsDetail] = useState<API.FormGoodsDetailVo>({});
  const [editingKey, setEditingKey] = useState('');//当前编辑的行
  const [soldTo, setSoldTo] = useState<API.SoldTo>();
  const [shipToCode, setShipToCode] = useState('');

  const isEditing = (record: any) => {
    return record.uid === editingKey
  };

  const edit = (record: Partial<any> & { key: React.Key }) => {
    //重新获取ProductCode、ProductName
    Product.getQueryPo(record.productId).then(response => {
      const newFormGoodsDetail: API.FormGoodsDetailVo = {
        ...record,
        productId: record.productId,
        productCode: response.data.productCode,
        productName: response.data.productName,
      };

      editingFormGoodsDetail.current = newFormGoodsDetail;
      formRef.current?.setFieldsValue({
        productId: {
          value: newFormGoodsDetail?.productId,
          label: wdiCore.String.CodeOrName(newFormGoodsDetail?.productCode, newFormGoodsDetail?.productName)
        },
        uom: response?.data?.uom,
        uomName: response?.data?.uomName,
        productType: response?.data?.productType,
        quantityConvert: newFormGoodsDetail.quantityConvert,
        unitPrice: newFormGoodsDetail.unitPrice,
        quantity: newFormGoodsDetail.quantity,
        amount: newFormGoodsDetail.amount,
      });
    });
    setEditingKey(record.uid);
  };
  const cancel = () => {
    setEditingKey('');
  };
  const save = async (key: React.Key) => {
    if (!validateEditItem()) {
      return false;
    }

    const row = editingFormGoodsDetail.current;
    const newData = [...dataSource];
    const index = newData.findIndex(item => key === item.uid);
    if (index > -1) {
      const item = newData[index];
      newData.splice(index, 1, {
        ...item,
        ...row,
      });
    } else {
      if (row) {
        newData.push(row);
      }
    }
    setDataSource(newData);
    setEditingKey('');
    editingFormGoodsDetail.current = undefined;
    return true;
  }

  const del = (key: any) => {
    if (window.confirm("确认要删除吗")) {
      setDataSource(DataStore.del(dataSource, key));
    }
  };

  const disabledDate: DatePickerProps['disabledDate'] = (current) => {
    return current < dayjs().startOf('day');
  };

  const validateEditItem = () => {
    const current = editingFormGoodsDetail.current;
    if (!current?.productId) {
      message.error("产品不能为空").then();
      return false;
    }
    if (!current.quantity || current.quantity <= 0) {
      message.error("申领数量不能为空且必须大于0").then();
      return false;
    }
    if (!current.unitPrice) {
      message.error(`产品【${current.productCode}】找不到价格`).then();
      return false;
    }
    if (current.priceDiscount && current.unitPrice < current.priceDiscount) {
      message.error(`客户【${soldTo?.codeOrName}】的产品【${current.productCode}】申领单价${current.unitPrice}不能小于促销供货价${current.priceDiscount}`).then();
      return false;
    }
    if (!current.amount || current.amount <= 0) {
      message.error("申领金额不能为空且必须大于0").then();
      return false;
    }
    if (dataSource.findIndex(item => (item.productId == current?.productId && item.uid != editingKey)) >= 0) {
      message.error(`申领产品【${wdiCore.String.CodeOrName(formGoodsDetail.productCode, formGoodsDetail.productName)} 】已申领，请检查`).then();
      return false;
    }
    return true;
  }

  const validateItem = () => {
    if (!formGoodsDetail) {
      message.error("产品不能为空").then();
      return false;
    }
    if (!formGoodsDetail.productId) {
      message.error("产品不能为空").then();
      return false;
    }
    if (!formGoodsDetail.quantity || formGoodsDetail.quantity <= 0) {
      message.error("申领数量不能为空且必须大于0").then();
      return false;
    }
    if (!formGoodsDetail.unitPrice) {
      message.error(`产品【${formGoodsDetail.productCode}】找不到价格`).then();
      return false;
    }
    if (formGoodsDetail.priceDiscount && formGoodsDetail.unitPrice < formGoodsDetail.priceDiscount) {
      message.error(`客户【${soldTo?.codeOrName}】的产品【${formGoodsDetail.productCode}】申领单价${formGoodsDetail.unitPrice}不能小于促销供货价${formGoodsDetail.priceDiscount}`).then();
      return false;
    }
    if (!formGoodsDetail.amount || formGoodsDetail.amount <= 0) {
      message.error("申领金额不能为空且必须大于0").then();
      return false;
    }

    if (dataSource.findIndex(item => item.productId == formGoodsDetail.productId) >= 0) {
      message.error(`申领产品【${wdiCore.String.CodeOrName(formGoodsDetail.productCode, formGoodsDetail.productName)} 】已申领，请检查`).then();
      return false;
    }
    return true;
  }

  const addItem = () => {
    if (validateItem()) {
      setDataSource(DataStore.add(dataSource, formGoodsDetail));
      setFormGoodsDetail({});
    }
  }

  const getProductPrice = async (formGoodsDetail: API.FormGoodsDetailVo) => {
    let newFormGoodsDetail = {...formGoodsDetail};
    newFormGoodsDetail.uom = formGoodsDetail?.uom;
    newFormGoodsDetail.uomName = formGoodsDetail?.uomName;
    newFormGoodsDetail.productType = formGoodsDetail?.productType;
    newFormGoodsDetail.quantityConvert = Number(formGoodsDetail?.quantityConvert);
    if (newFormGoodsDetail.productId) {
      const priceResp = await ProductPrice.getSoldToPriceSellin1({
        shipToCode: shipToCode,
        productId: newFormGoodsDetail.productId,
      });
      if (priceResp.code != ResponseStatus.SUCCESS) {
        message.error(priceResp.message);
      }
      if (priceResp.data) {
        newFormGoodsDetail = Object.assign({}, newFormGoodsDetail, {
          price: priceResp.data.priceInVat,
          unitPrice: priceResp.data.priceInVat,
        });
      }
      const crmTjResp = await ProductPrice.getCrmTj({
        soldToCode: soldTo?.soldToCode,
        shipToCode: shipToCode,
        productId: newFormGoodsDetail.productId,
      });
      if (crmTjResp.code != ResponseStatus.SUCCESS) {
        message.error(priceResp.message);
      } else {
        if (crmTjResp.data && !wdiCore.Object.IsNullOrUndefined(crmTjResp.data.priceInVat)) {
          newFormGoodsDetail = Object.assign({}, newFormGoodsDetail, {
            priceDiscount: crmTjResp.data.priceInVat,
          });
        } else {
          newFormGoodsDetail = Object.assign({}, newFormGoodsDetail, {
            priceDiscount: newFormGoodsDetail.price,
          });
        }
      }
    }
    if (newFormGoodsDetail.unitPrice && newFormGoodsDetail.quantity) {
      const amount = wdiCore.Number.ToNumber(newFormGoodsDetail.quantity * newFormGoodsDetail.unitPrice, 2);
      newFormGoodsDetail = Object.assign({}, newFormGoodsDetail, {amount: amount});
    }
    formRef.current?.setFieldsValue({
      uom: formGoodsDetail?.uom,
      uomName: formGoodsDetail?.uomName,
      productType: newFormGoodsDetail.productType,
      quantityConvert: formGoodsDetail?.quantityConvert,
      unitPrice: newFormGoodsDetail.unitPrice,
      quantity: newFormGoodsDetail.quantity,
      amount: newFormGoodsDetail.amount,
    });
    return newFormGoodsDetail;
  }

  const columns = [
    {
      title: '产品',
      dataIndex: 'productId',
      width: 300,
      editable: true,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.String.CodeOrName(record.productCode, record.productName);
      }
    },
    {
      title: '领用单位',
      dataIndex: 'uomName',
      width: 75,
      editable: true,
      render: (value: any, record: any) => {
        return value;
      }
    },
    {
      title: '正常供货价',
      dataIndex: 'price',
      width: 90,
      editable: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '促销供货价',
      dataIndex: 'priceDiscount',
      width: 90,
      editable: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '申领单价',
      width: 100,
      dataIndex: 'unitPrice',
      editable: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '申领数量',
      width: 100,
      dataIndex: 'quantity',
      editable: true,
      ellipsis: true,
      render: (value: any, record: any) => {
        return value;
      }
    },
    {
      title: '申领金额',
      width: 110,
      dataIndex: 'amount',
      editable: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: 80,
      render: (_: any, record: any) => {
        return isEditing(record) ? (
          <>
            <Typography.Link onClick={() => save(record.uid)} style={{marginRight: 8}}>
              更新
            </Typography.Link>
            <Typography.Link onClick={() => cancel()}>
              取消
            </Typography.Link>
          </>
        ) : (
          <>
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)} style={{marginRight: 8}}>
              编辑
            </Typography.Link>
            <Typography.Link onClick={() => del(record.uid)}>
              删除
            </Typography.Link>
          </>)
      }
    },
  ];

  const mergedColumns = columns.map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const EditableCell: React.FC<EditableCellProps> = ({
                                                       editing,
                                                       dataIndex,
                                                       title,
                                                       record,
                                                       index,
                                                       children,
                                                       ...restProps
                                                     }) => {
    let inputNode = children;
    if (dataIndex == 'productId') {
      inputNode = (
        <WdiSelect
          placeholder="请录入或选择"
          showSearch={true}
          remote={true}
          style={{width: '100%'}}
          onChange={async (value, option) => {
            let newFormGoodsDetail: API.FormGoodsDetailVo = {
              quantity: editingFormGoodsDetail.current?.quantity,
            };
            const productId = WdiSelectFormat.getvalue(value);
            if (productId) {
              const productResponse = await Product.getQueryPo(productId);
              if (productResponse.code == ResponseStatus.SUCCESS) {
                const product = productResponse.data;
                if (product) {
                  newFormGoodsDetail = Object.assign({}, newFormGoodsDetail, {
                    productId: product.productId,
                    productCode: product.productCode,
                    productName: product.productName,
                    uom: product.uom,
                    uomName: product.uomName,
                    productType: product.productType,
                    quantityConvert: product.quantityConvert,
                  });
                  formRef.current?.setFieldsValue({
                    productId: {
                      value: newFormGoodsDetail?.productId,
                      label: wdiCore.String.CodeOrName(newFormGoodsDetail?.productCode, newFormGoodsDetail?.productName)
                    },
                  });
                  newFormGoodsDetail = await getProductPrice(newFormGoodsDetail);
                }
              }
            }
            editingFormGoodsDetail.current = newFormGoodsDetail;
          }}
          reloadKey={soldTo?.salesOrgCode}
          dataLoading={async (params) => {
            const responseResult = await Product.ajaxSearchSku(Object.assign({
              isActive: true,
              productTypes: [Enum.ProductType.FINISHED, Enum.ProductType.NON_FINISHED].join(),
              soldToCode: soldTo?.soldToCode
            }, params));
            return responseResult.data?.map((item) => {
              return {value: item.productId, label: item.codeOrName};
            });
          }}
        />
      );
    } else if (dataIndex == 'quantity') {
      inputNode = (
        <WdiInputNumber
          digits={5}
          onBlur={(e: any) => {
            const quantity = wdiCore.Number.ToNumber(e.target.value, 5);
            let newFormGoodsDetail = Object.assign({}, editingFormGoodsDetail.current, {quantity: quantity});
            if (newFormGoodsDetail?.unitPrice) {
              const amount = wdiCore.Number.ToNumber(quantity * newFormGoodsDetail.unitPrice, 2);
              newFormGoodsDetail = Object.assign({}, newFormGoodsDetail, {amount: amount});
            }
            editingFormGoodsDetail.current = newFormGoodsDetail;
            formRef.current?.setFieldsValue({
              quantity: newFormGoodsDetail.quantity,
              amount: newFormGoodsDetail.amount,
            });
          }}
        />
      );
    } else if (dataIndex == 'unitPrice') {
      inputNode = (
        <WdiInputNumber
          digits={2}
          onBlur={(e: any) => {
            const unitPrice = wdiCore.Number.ToNumber(e.target.value, 5);
            let newFormGoodsDetail = Object.assign({}, editingFormGoodsDetail.current, {unitPrice: unitPrice});
            if (newFormGoodsDetail?.quantity) {
              const amount = wdiCore.Number.ToNumber(newFormGoodsDetail?.quantity * unitPrice, 2);
              newFormGoodsDetail = Object.assign({}, newFormGoodsDetail, {amount: amount});
            }
            editingFormGoodsDetail.current = newFormGoodsDetail;
            formRef.current?.setFieldsValue({
              quantity: newFormGoodsDetail.quantity,
              amount: newFormGoodsDetail.amount,
            });
          }}
        />
      );
    } else if (dataIndex == 'uom' || dataIndex == 'amount') {
      inputNode = <Input style={{background: 'none', border: 'none'}} readOnly/>;
    }
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{margin: 0}}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  useEffect(() => {
    if (data.soldToCode) {
      SoldTo.get(data.soldToCode).then(responseResult => {
        setSoldTo(responseResult.data);
        formRef.current?.setFieldsValue({
          soldToName: responseResult.data.codeOrName,
        });
      })
    }
    if (data.formGoods) {
      const formGoods = data.formGoods;
      formRef.current?.setFieldsValue({
        expectDeliveryDate: formGoods?.expectDeliveryDate ? moment(formGoods?.expectDeliveryDate, "YYYY-MM-DD") : undefined,
        expectArrivalDate: formGoods?.expectArrivalDate ? moment(formGoods?.expectArrivalDate, "YYYY-MM-DD") : undefined,
        remark: formGoods.remark,
        address: formGoods.address,
      });
      if (formGoods.shipToCode) {
        setShipToCode(formGoods.shipToCode);
        ShipTo.get(formGoods.shipToCode).then(responseResult => {
          formRef.current?.setFieldsValue({
            shipToCode: {
              label: wdiCore.String.CodeOrName(responseResult.data.codeOrName, responseResult.data.address),
              value: responseResult.data.shipToCode
            },
            address: responseResult.data.address,
          });
        })
      }
      if (formGoods.formGoodsDetails) {
        setDataSource(DataStore.init(formGoods.formGoodsDetails));
      }
    }
  }, [data]);

  const handleShipToChange = async (value: any) => {
    const code = WdiSelectFormat.getvalue(value);
    setShipToCode(code);
    const responseResult = await ShipTo.get(code);
    const shipTo = responseResult?.data;
    if (!shipTo) {
      setFormGoodsDetail({quantity: formGoodsDetail.quantity, uid: formGoodsDetail.uid})
    }
    formRef.current?.setFieldsValue({
      shipToCode: shipTo ? {
        label: wdiCore.String.CodeOrName(shipTo.codeOrName, shipTo.address),
        value: shipTo.shipToCode
      } : undefined,
      address: shipTo?.address,
    });
    if (dataSource && dataSource.length > 0) {
      const newDataSource = [...dataSource];
      const pricePromises = newDataSource.map(async (record) => {
        if (record.productId) {
          const priceResp = await ProductPrice.getSoldToPriceSellin1({
            shipToCode: code,
            productId: record.productId,
          });

          if (priceResp.code !== ResponseStatus.SUCCESS) {
            message.error(priceResp.message);
            record.unitPrice = undefined;
            record.amount = undefined;
            return;
          }

          if (priceResp.data?.priceInVat != null) {
            record.unitPrice = priceResp.data.priceInVat;
          }

          if (record.unitPrice && record.quantity) {
            record.amount = wdiCore.Number.ToNumber(record.quantity * record.unitPrice, 2);
          }
        }
      });

      await Promise.all(pricePromises);

      setDataSource(newDataSource);
    }
  }

  return (
    <WdiModalForm
      formRef={formRef}
      labelAlign='left'
      layout="vertical"
      title={props.title}
      visible={props.visible}
      modalProps={{
        width: 1000,
        onCancel: () => {
          props.onClose ? props.onClose() : null
        },
      }}
      onFinish={async (values) => {
        const {shipToCode, expectDeliveryDate, expectArrivalDate, deliveryLineCode, ...entity} = values;
        let formGoodsDetails = [...dataSource];
        if (formGoodsDetail && formGoodsDetail.productId) {
          if (!validateItem()) {
            return;
          }
          formGoodsDetails = DataStore.add(dataSource, formGoodsDetail);
        }

        if (editingFormGoodsDetail.current && editingFormGoodsDetail.current.productId) {
          if (!validateEditItem()) {
            return;
          }
          formGoodsDetails = DataStore.edit(dataSource, editingFormGoodsDetail.current);
        }

        if (formGoodsDetails.length <= 0) {
          message.error("请填写申领明细！");
          return;
        }
        entity.soldToCode = data.soldToCode;
        entity.shipToCode = WdiSelectFormat.getvalue(shipToCode);
        entity.expectDeliveryDate = moment(expectDeliveryDate).format("YYYY-MM-DD");
        entity.expectArrivalDate = moment(expectArrivalDate).format("YYYY-MM-DD");
        entity.formGoodsDetails = formGoodsDetails;

        const findIndex = props?.data?.dataSource?.findIndex((item: any) =>
          item.soldToCode == entity.soldToCode
          && item.shipToCode == entity.shipToCode
          && item.expectDeliveryDate == entity.expectDeliveryDate
          && item.expectArrivalDate == entity.expectArrivalDate);
        if (findIndex >= 0) {
          message.error(`与第${findIndex + 1}行信息重复，请检查`).then();
          return;
        }
        const response = await FormSp.Buttons.validateGoods({
          rowIndex: data.rowIndex,
          pageTypeId: data.pageTypeId,
          formGoods: entity,
          formGoodsList: data.formGoodsList
        });
        if (response.code !== ResponseStatus.SUCCESS) {
          message.error(response.message);
          return;
        }
        if (props.onSave) {
          props.onSave({
            code: ResponseStatus.SUCCESS,
            data: response.data,
          });
        }
      }}
    >
      <Row gutter={[10, 0]}>
        <Col className="gutter-row" span={6}>
          <Form.Item label="客户" name="soldToName">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="收货地" name="shipToCode" rules={[{required: true, message: '收货地不能为空!'}]}>
            <WdiSelect {...{
              placeholder: "请选择收货地",
              showSearch: true,
              defaultParamKey: "shipToCodes",
              remote: true,
              reloadKey: data?.soldToCode,
              labelInValue: true,
              dataLoading: async (params) => {
                const responseResult = await ShipTo.ajaxSearch(Object.assign({
                  soldToCode: data?.soldToCode,
                  isActive: true,
                  isFilterValueAddress: true
                }, params));
                if (responseResult?.data?.length == 1) {
                  setShipToCode(responseResult.data[0].shipToCode);
                  formRef.current?.setFieldsValue({
                    shipToCode: responseResult.data[0].shipToCode
                  })
                }
                return (responseResult?.data ?? []).map((item) => {
                  return {value: item.shipToCode, label: wdiCore.String.Join(item.codeOrName, item.address)};
                });
              },
              onChange: handleShipToChange,
            }} />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item
            label="要求出库日期" name="expectDeliveryDate"
            rules={[{required: true, message: '要求出库日期不能为空!'}]}
          >
            <DatePicker picker={"date"} format={"YYYY-MM-DD"} disabledDate={disabledDate}/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item
            label="要求到货日期" name="expectArrivalDate"
            rules={[{required: true, message: '要求到货日期不能为空!'}]}
          >
            <DatePicker picker={"date"} format={"YYYY-MM-DD"} disabledDate={disabledDate}/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={12}>
          <Form.Item label="备注" name="remark">
            <Input/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="地址" name="address">
            <Input readOnly/>
          </Form.Item>
        </Col>
      </Row>
      <WdiPanel title={<WdiCardTitle title='申领明细'/>}>
        <WdiTable
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          columns={mergedColumns}
          rowKey="uid"
          dataSource={dataSource}
          pagination={false}
          aggrColumns={['amount']}
          extraFooterSummary={() => {
            return (<Table.Summary.Row>
              <Table.Summary.Cell index={0}>
                <WdiSelect
                  placeholder="请录入或选择"
                  showSearch={true}
                  remote={true}
                  value={{
                    label: wdiCore.String.CodeOrName(formGoodsDetail?.productCode, formGoodsDetail?.productName),
                    value: formGoodsDetail?.productId
                  }}
                  style={{width: '100%'}}
                  labelInValue={true}
                  onChange={async (value) => {
                    if (!shipToCode) {
                      message.error("请先选择收货地");
                      setFormGoodsDetail({quantity: formGoodsDetail.quantity, uid: formGoodsDetail.uid})
                      return;
                    }
                    let newFormGoodsDetail: API.FormGoodsDetailVo = {
                      quantity: formGoodsDetail?.quantity,
                    };
                    const productId = WdiSelectFormat.getvalue(value);
                    if (productId) {
                      const productResp = await Product.getQueryPo(productId);
                      if (productResp.code == ResponseStatus.SUCCESS) {
                        const product = productResp.data;
                        if (product) {
                          newFormGoodsDetail = Object.assign({}, newFormGoodsDetail, {
                            productId: product.productId,
                            productCode: product.productCode,
                            productName: product.productName,
                            uom: product.uom,
                            uomName: product.uomName,
                            productType: product.productType,
                            quantityConvert: product.quantityConvert,
                          });
                          newFormGoodsDetail = await getProductPrice(newFormGoodsDetail);
                        }
                      }
                    }
                    setFormGoodsDetail(newFormGoodsDetail);
                  }}
                  reloadKey={soldTo?.salesOrgCode}
                  dataLoading={async (params) => {
                    const responseResult = await Product.ajaxSearchSku(Object.assign({
                      isActive: true,
                      productTypes: [Enum.ProductType.FINISHED, Enum.ProductType.NON_FINISHED].join(),
                      soldToCode: soldTo?.soldToCode
                    }, params));
                    return responseResult.data?.map((item: any) => {
                      return {value: item.productId, label: item.codeOrName};
                    });
                  }}
                />
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                {formGoodsDetail?.uomName}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2}>
                {formGoodsDetail?.price}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3}>
                {formGoodsDetail?.priceDiscount}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={4}>
                <WdiInputNumber
                  digits={2} value={formGoodsDetail?.unitPrice}
                  onBlur={(e: any) => {
                    const unitPrice = wdiCore.Number.ToNumber(e.target.value, 5);
                    let newFormGoodsDetail = Object.assign({}, formGoodsDetail, {unitPrice: unitPrice});
                    if (newFormGoodsDetail?.quantity) {
                      const amount = wdiCore.Number.ToNumber(unitPrice * newFormGoodsDetail.quantity, 2);
                      newFormGoodsDetail = Object.assign({}, newFormGoodsDetail, {amount: amount});
                    }
                    setFormGoodsDetail(newFormGoodsDetail);
                  }}
                />
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5}>
                <WdiInputNumber
                  digits={5} value={formGoodsDetail?.quantity}
                  onBlur={(e: any) => {
                    const quantity = wdiCore.Number.ToNumber(e.target.value, 5);
                    let newFormGoodsDetail = Object.assign({}, formGoodsDetail, {quantity: quantity});
                    if (newFormGoodsDetail?.unitPrice) {
                      const amount = wdiCore.Number.ToNumber(quantity * newFormGoodsDetail.unitPrice, 2);
                      newFormGoodsDetail = Object.assign({}, newFormGoodsDetail, {amount: amount});
                    }
                    setFormGoodsDetail(newFormGoodsDetail);
                  }}
                />
              </Table.Summary.Cell>
              <Table.Summary.Cell index={6}>
                {formGoodsDetail?.amount}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5}>
                <Typography.Link onClick={() => addItem()}>
                  新增
                </Typography.Link>
              </Table.Summary.Cell>
            </Table.Summary.Row>)

          }}
        />
      </WdiPanel>

    </WdiModalForm>
  );
}
export default FormGoodsEditApp;

type FormGoodsViewAppProps = {
  form?: API.Form
} & WdiModalAppProps

export const FormGoodsViewApp: React.FC<FormGoodsViewAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  const [dataSource, setDataSource] = useState<API.FormGoodsDetailVo[]>([]);
  const [shippingDataSource, setShippingDataSource] = useState<API.FormGoodsDetailVo[]>([]);

  const columns = [
    {
      title: '申领明细ID',
      dataIndex: 'formGoodsDetailId',
      width: 200,
      ellipsis: true,
      render: (value: any, record: any) => {
        return [props.form?.formNo, record?.formGoodsId, record?.formGoodsDetailId].join('-')
      }
    },
    {
      title: '产品',
      dataIndex: 'productId',
      width: 300,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.String.CodeOrName(record.productCode, record.productName);
      }
    },
    {
      title: '领用单位',
      dataIndex: 'uomName',
      width: 75,
      ellipsis: true,
    },
    {
      title: '正常供货价',
      dataIndex: 'price',
      width: 90,
      ellipsis: true,
      render: (value: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '促销供货价',
      dataIndex: 'priceDiscount',
      width: 90,
      ellipsis: true,
      render: (value: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '申领单价',
      width: 100,
      dataIndex: 'unitPrice',
      ellipsis: true,
      render: (value: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '申领数量',
      width: 100,
      dataIndex: 'quantity',
      ellipsis: true,
      render: (value: any) => {
        return value;
      }
    },
    {
      title: '申领金额',
      width: 110,
      dataIndex: 'amount',
      ellipsis: true,
      render: (value: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
  ];

  const shippingColumns = [
    {
      title: '订单编号',
      dataIndex: 'orderNo',
      width: 120,
      ellipsis: true
    },
    {
      title: '产品',
      dataIndex: 'productId',
      width: 200,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.String.CodeOrName(record.productCode, record.productName);
      }
    },
    {
      title: '发货数量',
      dataIndex: 'quantity',
      width: 100,
      ellipsis: true
    },
    {
      title: '申领单价',
      dataIndex: 'unitPrice',
      width: 100,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '发货金额',
      dataIndex: 'amount',
      width: 100,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.AmountToString(value);
      }
    },
    {
      title: '发货日期',
      dataIndex: 'billingDate',
      width: 120,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Date.DateToString(value);
      }
    },
    // {
    //   title: '收货地',
    //   dataIndex: 'shipToCode',
    //   width: 200,
    //   ellipsis: true,
    //   render: (value: any, record: any) => {
    //     return wdiCore.String.CodeOrName(record.shipToCode, record.shipToName);
    //   }
    // },
  ];

  useEffect(() => {
    if (props.data?.formGoods) {
      const formGoods = props.data.formGoods;
      formRef.current?.setFieldsValue({
        soldToCode: wdiCore.String.CodeOrName(formGoods.soldToCode, formGoods.soldToName),
        shipToCode: wdiCore.String.CodeOrName(formGoods.shipToCode, formGoods.shipToName),
        expectDeliveryDate: wdiCore.Date.DateToString(formGoods?.expectDeliveryDate),
        expectArrivalDate: wdiCore.Date.DateToString(formGoods?.expectArrivalDate),
        remark: formGoods.remark,
        address: formGoods.address,
        deliveredOperator: wdiCore.Object.IsNullOrUndefined(formGoods.deliveredOperator) && formGoods.isDelivered ? '系统' : formGoods.deliveredOperator,
        deliveredSetupDate: wdiCore.Date.DateToString(formGoods?.deliveredSetupDate),
      });
      ShipTo.get(formGoods.shipToCode).then(responseResult => {
        formRef.current?.setFieldsValue({
          address: responseResult.data.address,
        });
      })
      setDataSource(formGoods.formGoodsDetails);
      FormGoodsShipping.getFormGoodsShipping(formGoods.formGoodsId).then(response => {
        setShippingDataSource(DataStore.init(response.data));
      })
    }
  }, [props.data]);

  return (
    <WdiModalForm
      formRef={formRef}
      labelAlign='left'
      layout="vertical"
      title={props.title}
      visible={props.visible}
      submitter={false}
      modalProps={{
        width: 1000,
        onCancel: () => {
          props.onClose ? props.onClose() : null
        },
        destroyOnClose: true,
        maskClosable: false
      }}
    >
      <Row gutter={[10, 0]}>
        <Col className="gutter-row" span={6}>
          <Form.Item label="客户" name="soldToCode">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="收货地" name="shipToCode">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="要求出库日期" name="expectDeliveryDate">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="要求到货日期" name="expectArrivalDate">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="备注" name="remark">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="地址" name="address">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="发货完成设置人" name="deliveredOperator">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={6}>
          <Form.Item label="发货完成设置日期" name="deliveredSetupDate">
            <WdiInput readOnly/>
          </Form.Item>
        </Col>
      </Row>
      <WdiPanel title={<WdiCardTitle title='申领明细'/>}>
        <WdiTable
          columns={columns}
          rowKey="uid"
          dataSource={dataSource}
          pagination={false}
          aggrColumns={['amount']}
        />
      </WdiPanel>
      <WdiPanel title={<WdiCardTitle title='发货明细'/>}>
        <WdiTable
          columns={shippingColumns}
          rowKey="uid"
          dataSource={shippingDataSource}
          pagination={false}
          aggrColumns={['amount']}
        />
      </WdiPanel>

    </WdiModalForm>
  );
}
